import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserService } from '../user/user.service';

@Injectable({ providedIn: 'root' })
export class NotLoggedService {
  private dSub: Subscription = new Subscription();

  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
  ) {}

  public execute(
    fun: () => any,
    params: { signup: string; signin: string; profileemailconfirm: string } = {
      signup: 'true',
      signin: null,
      profileemailconfirm: null,
    },
  ) {
    this.dSub.unsubscribe();
    this.dSub = this.dialog.afterOpened.subscribe({
      next: dialog => {
        if (dialog.id === 'sign-in' || dialog.id === 'sign-up' || dialog.id === 'profileemailconfirm') {
          this.dSub.unsubscribe();
          this.execute(fun, {
            signup: dialog.id === 'sign-up' ? 'true' : null,
            signin: dialog.id === 'sign-in' ? 'true' : null,
            profileemailconfirm: dialog.id === 'profileemailconfirm' ? 'true' : null,
          });
        } else {
          this.dSub.unsubscribe();
        }
      },
    });
    if (!this.userService.user || !this.userService.user?.confirmedAt) {
      this.router
        .navigate([], {
          relativeTo: this.route,
          queryParams: params,
          queryParamsHandling: 'merge',
          skipLocationChange: true,
        })
        .then(() => {
          const dialog = this.dialog.getDialogById(
            params.signin ? 'sign-in' : params.signup ? 'sign-up' : 'profileemailconfirm',
          );
          if (dialog) {
            const subscription = dialog?.afterClosed().subscribe(res => {
              if (!!res && this.userService.user) {
                if (this.userService.user?.confirmedAt) {
                  fun();
                  this.dSub.unsubscribe();
                } else {
                  this.dSub.unsubscribe();
                  subscription.unsubscribe();
                  this.execute(fun, { signup: null, signin: null, profileemailconfirm: 'true' });
                }
              } else if (!res || res === 'do-nothing') {
                this.dSub.unsubscribe();
              }
              subscription.unsubscribe();
            });
          }
        });
    } else {
      fun();
    }
  }
}
